module.exports = __webpack_public_path__ + "static/media/bf.d5e3c44e.svg";